<ng-container *transloco="let t">
    <mat-card
        class="altair-card ports-card bg-white border-radius border-none d-block"
        [class.component-dark-theme]="themeService.isDark()"
    >
        @if (scan) {
        <mat-card-content>
            <h5 class="header-title mb-0">
                <span class="badge text-soft-info">{{ data.length }}</span>
                {{ t("discovered-ports") }}
            </h5>
            <small class="text-danger float-end">
                {{ t("ports-highlighted") }}
            </small>
            <br />
            @for (item of data; track item) { @if (item.is_uncommon) {
            <span
                class="badge text-soft-danger info"
                data-toggle="tooltip"
                data-placement="top"
                title="{{ item.description }}"
            >
                {{ item.number }}/{{ item.service_name }}
            </span>
            } @else {
            <span
                class="badge text-soft-info info"
                data-toggle="tooltip"
                data-placement="top"
                title="{{ item.description }}"
            >
                {{ item.number }}/{{ item.service_name }}
            </span>
            } }
        </mat-card-content>
        }
    </mat-card>
</ng-container>
